import { ROUTES } from "../../shared";
import DriverFilters from "./PageFilters/DriverFilters/DriverFilters";
import FilesFilters from "./PageFilters/FilesFilters/FilesFilters";
import SharedIntegrationsFilters from "./PageFilters/SharedIntegrationsFilters/SharedIntegrationsFilters";
import VehicleFilters from "./PageFilters/VehicleFilters/VehicleFilters";

interface FiltersProps {
  route: ROUTES;
}

const Filters = ({ route }: FiltersProps) => {
  const renderFilters = () => {
    switch (route) {
      case ROUTES.Vehicles:
        return <VehicleFilters />;

      case ROUTES.Drivers:
        return <DriverFilters />;

      case ROUTES.VehicleFiles:
      case ROUTES.DriverFiles:
        return <FilesFilters route={route} />;

      case ROUTES.Integrations:
      case ROUTES.IntegrationsApi:
      case ROUTES.AnalysisProviders:
        return <SharedIntegrationsFilters route={route} />;

      default:
        return null;
    }
  };

  return renderFilters();
};

export default Filters;
